import React from "react";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import { useState } from "react";
import BestMango from './BestMango'
import GoodMango from './GoodMango'
import BadMango from './BadMango'
import { useRecordArticleRating } from "hooks/api/useRecordArticleRating";
import {useRouter} from 'next/router'
import {useQuery} from '@apollo/react-hooks'
import gql from 'graphql-tag'
import { getStoryAuthor, getStoryCategories } from "data/api/ApiStory";
import { getAuthorId } from 'data/api/ApiAuthor'
import { useRecordArticleRated } from "hooks/analytics/useRecordArticleRated";

const FeedbackContainer = styled.div.attrs({
	className: "h-64 w-full px-2 flex flex-col text-center items-center justify-center"
})``;

const ButtonsContainer = styled.div.attrs({
	className: "flex items-center justify-center flex-row"
})``;

const FeedbackButton = styled<any>(Button).attrs({ className: "p-5 bg-transparent border-none" })``;

const ButtonContainer = styled.div.attrs({ className: "flex flex-col" })``;

const SmallText = styled.p.attrs({ className: "text-center text-sm normal-case" })`
	font-family: ${props => props.theme.fonts.poppins};
`;

const LargeText = styled.p.attrs({ className: "text-center text-md" })`
	font-family: ${props => props.theme.fonts.poppins};
`;

const currentUserHasRatedArticleQuery = gql`
	query currentUserHasRatedArticleQuery($articleId: ID!) {
		currentUserHasRatedArticle(articleId: $articleId)
	}
`

function useCurrentUserHasRatedArticle(articleId: string) {
	const { loading, data } = useQuery(currentUserHasRatedArticleQuery, { variables: { articleId } })
	const currentUserHasRatedArticle = data?.currentUserHasRatedArticle;
	return { loading, currentUserHasRatedArticle }
}

export default ({ story }) => {
	const [feedbackSent, setFeedbackSent] = useState(false);
	const [nameOfFeedbackGiven, setNameOfFeedbackGiven] = useState("")

	const { query: { id: articleId } }: any = useRouter()

	const { recordArticleRating } = useRecordArticleRating()
	const { loading, currentUserHasRatedArticle } = useCurrentUserHasRatedArticle(articleId)

	const recordArticleRated = useRecordArticleRated(story)

	async function recordFeedback(storyRating: string) {
		recordArticleRated(storyRating)
		await recordArticleRating(articleId)
		setNameOfFeedbackGiven(storyRating)
		setFeedbackSent(true);
	};

	return (
		<>
			{(loading || currentUserHasRatedArticle)
			? (
				<></>
			) : (
				<FeedbackContainer>
					{!feedbackSent ? (
						<>
							<LargeText>
								What did you think of this story? Click a mango to give us feedback.
							</LargeText>
							<ButtonsContainer>
								<ButtonContainer>
									<FeedbackButton id="meh-rating" onClick={() => recordFeedback("meh")}>
										<BadMango style={{ margin: "0" }} />
										<br />
									</FeedbackButton>
									<SmallText>Meh</SmallText>
								</ButtonContainer>
								<ButtonContainer id="good-rating">
									<FeedbackButton onClick={() => recordFeedback("good")}>
										<GoodMango style={{ margin: "0" }} />
										<br />
									</FeedbackButton>
									<SmallText>Good</SmallText>
								</ButtonContainer>
								<ButtonContainer>
									<FeedbackButton id="great-rating" onClick={() => recordFeedback("great")}>
										<BestMango style={{ margin: "0" }} />
										<br />
									</FeedbackButton>
									<SmallText>Great</SmallText>
								</ButtonContainer>
							</ButtonsContainer>
						</>
					) : (
					<LargeText>Thank you for submitting your feedback! You rated this article as {nameOfFeedbackGiven}</LargeText>
					)}
				</FeedbackContainer>
			)}
		</>
	);
};
